/**
 * @generated SignedSource<<c275a6bcf1090c33aa549f3592d4b029>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlaylistRouteData$data = {
  readonly __typename: string;
  readonly description?: string | null | undefined;
  readonly entries?: ReadonlyArray<{
    readonly node: {
      readonly __typename: "AuthorizedEvent";
      readonly " $fragmentSpreads": FragmentRefs<"VideoListEventData">;
    } | {
      readonly __typename: "Missing";
      readonly __typename: "Missing";
    } | {
      readonly __typename: "NotAllowed";
      readonly __typename: "NotAllowed";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  }>;
  readonly id?: string;
  readonly title?: string;
  readonly " $fragmentSpreads": FragmentRefs<"PlaylistBlockPlaylistData">;
  readonly " $fragmentType": "PlaylistRouteData";
};
export type PlaylistRouteData$key = {
  readonly " $data"?: PlaylistRouteData$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlaylistRouteData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PlaylistRouteData",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "PlaylistEntry",
          "kind": "LinkedField",
          "name": "entries",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "VideoListEventData",
                      "selections": [
                        (v1/*: any*/),
                        (v2/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "created",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "creators",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isLive",
                          "storageKey": null
                        },
                        (v3/*: any*/),
                        {
                          "condition": "includeSeries",
                          "kind": "Condition",
                          "passingValue": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Series",
                              "kind": "LinkedField",
                              "name": "series",
                              "plural": false,
                              "selections": [
                                (v2/*: any*/),
                                (v1/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ]
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SyncedEventData",
                          "kind": "LinkedField",
                          "name": "syncedData",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "thumbnail",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "duration",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "startTime",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "endTime",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "audioOnly",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "includeSeries",
                          "value": true
                        }
                      ],
                      "argumentDefinitions": [
                        {
                          "defaultValue": false,
                          "kind": "LocalArgument",
                          "name": "includeSeries"
                        }
                      ]
                    }
                  ],
                  "type": "AuthorizedEvent",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "AuthorizedPlaylist",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PlaylistBlockPlaylistData"
    }
  ],
  "type": "Playlist",
  "abstractKey": "__isPlaylist"
};
})();

(node as any).hash = "58b2a28259a5d6ece7d531ec657f45a2";

export default node;
